<template>
  <div>
    <el-card class="box-card">

      <div class="div_buttom">
        <el-button size="medium" @click="flushedList">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="ID" width="100">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <!-- <el-table-column prop="pid" label="父级">
          <template slot-scope="scope">{{ scope.row.pid }}</template>
        </el-table-column> -->
        <el-table-column prop="name" label="名称">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>异常</el-tag>
          </template>

        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button type="text" style="color: red" size="medium" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="queryParams.pageNo"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
      />

    </el-card>
    <div class="drawer-wrapper">
      <el-drawer :wrapperClosable="true" :title="title" :visible.sync="open" size="50%" append-to-body>
        <div class="demo-drawer__content">
          <el-form :model="form" size="medium" class="centered-form">
            <el-row :gutter="gutter">
              <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20" v-if="false">
                <el-form-item label="父级:" label-width="100px">
                  <el-select v-model="form.pid" placeholder="请选择父级" clearable class="w100">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled">
                    </el-option>
                  </el-select>


                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
                <el-form-item label="名称:" label-width="100px">
                  <el-input v-model="form.name" size="medium"></el-input>
                </el-form-item>
              </el-col>


              <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20" v-if="false">
                <el-form-item label="权限:" label-width="100px">

                  选中全部:
                  <el-switch
                      v-model="allSwitchValue"
                      @change="allSwitchChange"
                      active-color="#13ce66"

                      inactive-color="#ff4949">
                  </el-switch>
                  展开全部:
                  <el-switch
                      v-model="unfoldSwitchValue"
                      @change="unfoldSwitchChange"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                  </el-switch>
                </el-form-item>
              </el-col>


              <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20" v-if="roleId == 1">
                <el-form-item label="" label-width="100px">
                  <el-tree
                      :data="data"
                      show-checkbox
                      ref="tree"
                      node-key="id"

                      :default-expand-all="expandAll"
                      @check="(click, checked)=>{handleCheckChange(click, checked)}"
                      :props="props">
                  </el-tree>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20" v-if="roleId == 1">
                <el-form-item label="状态" label-width="100px">
                  <el-radio-group v-model="form.status">
                    <el-radio :label="1" :value="1"> 正常</el-radio>
                    <el-radio :label="0" :value="1">隐藏</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="demo-drawer__footer">
          <div class="footer-buttons">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </div>
        </div>

      </el-drawer>
    </div>
  </div>
</template>

<script>
import {optimizationAPI} from '@/api/authRule/role';
import {useMenuApi} from '@/api/menu/index';
import {processErrors} from "@/utils/errorHandler";
import { Session } from '@/utils/storage';

export default {
  components: {},
  data() {
    return {
      roleId: 0,
      SearchFlag: false,
      // 总条数
      total: 0,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      open: false,
      title: "添加",
      form: {
        id: '',
        pid: 0,
        rules: '',
        name: '',
        status: 1// 默认值1
      },
      options: [
        {
          value: 0,
          label: '无父级'
        }
      ],
      tableData: [],
      multipleSelection: [],
      data: [
        // Your tree data here
      ],
      rulesIdList: [],
      rulesIds: "",
      props: {
        label: 'title',
        children: 'children',
        id: 'id',
        pid: 'pid'
      },
      // 展开全部
      expandAll: true,
      // 选择权限
      allSwitchValue: false,
      unfoldSwitchValue: true,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      gutter: 20,
      loading: false,
    };
  },
  created() {
    this.getList()
    this.getMenuList()
    this.getParent()
    this.roleId = Session.get('roleId');
  },
  methods: {
    // 获取父级列表
    getParent() {
      // 1.查询列表
      let api = optimizationAPI()
      let query = {
        "pageNo": 1,
        "pageSize": 9999
      }
      api.getRoleList(query).then().then(res => {
        if (res.code == 0) {
          res.data.data.forEach(item => {
            this.options.push({
              value: item.id,
              label: item.name,
              disabled: false
            })

          })
        } else {
          processErrors(res);
        }
      })
    },
    // 获取角色组列表
    getList() {
      this.loading = true
      let api = optimizationAPI()
      api.getRoleList(this.queryParams).then().then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },
    // 刷新列表
    flushedList() {
      this.getList()
    },
    handleAdd() {
      this.open = true
      this.reset()
      this.$refs.tree.setCheckedNodes([]);
      this.allSwitchValue = false
      this.rulesIds = "14,113,110"; // 清空data
      this.title = "添加"
      console.log(this.rulesIds)
      // 回显被选中树
        this.rulesIds.split(",").forEach(val => {
          this.$nextTick(() => {
            this.$refs.tree.setChecked(val, true, false);
          });
        });
    },
    // 保存角色组
    submit() {
      let api = optimizationAPI()
      this.form.rules = this.rulesIds
      if (this.form.id != null) {
        api.addAndEditRole(this.form).then(response => {
          if (response.code == 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: '修改失败',
              type: 'error'
            });
          }
          this.open = false;
          this.getList();
        });
      } else {
        api.addAndEditRole(this.form).then(response => {
          if (response.code == 0) {
            this.$message({
              message: '新增成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: '新增失败',
              type: 'error'
            });
          }
          this.open = false;
          this.getList();
        });
      }

    },
    // 取消
    cancel() {
      this.reset()
      this.open = false
      this.getList()
    },
    // 获取全部菜单列表
    getMenuList() {
      let api = useMenuApi().getMenu()
      api.then(res => {
        if (res.code == 0) {
          this.data = res.data
        } else {
          processErrors(res);
        }
      })
    },
    // 重置
    reset() {
      this.form = {
        name: "",
        pid: 0,
        status: 1,
        rules: "14,113,110",
      }
    },
    // 获取详情
    handleUpdate(row) {
      this.reset()

      let api = optimizationAPI();
      const id = row.id

      api.getRoleInfo(id).then(res => {

        if (res.code == 0) {
          this.form = res.data
          this.open = true;
          this.title = "修改"
          // 回显被选中树
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys([]); // Clear all checked nodes


            // Set the new selections
            this.form.rules.split(",").forEach(val => {
              this.$nextTick(() => {
                this.$refs.tree.setChecked(val, true, false);
              });
            });
          });
        } else {
          processErrors(res);
        }
      })
    },
    // 获取选择的节点数组
    handleCheckChange(click, checked) {

      //选中的子节点
      let checkedKeys = this.$refs.tree.getCheckedKeys();
      // 获取选中的父节点
      let hafCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
      let functionIdList = checkedKeys.concat(hafCheckedKeys)


      // 拼接字符串
      this.rulesIds = functionIdList.join(",");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 选中全部
    allSwitchChange() {
      this.rulesIds = ""
      if (this.allSwitchValue) {
        // 设置所有节点为选中状态
        this.$refs.tree.setCheckedNodes(this.data);

        // 初始化一个空数组来存储选中节点的ID
        let checkedIds = [];

        // 获取所有选中节点并将它们的ID添加到数组中
        let checkedNodes = this.$refs.tree.getCheckedNodes();
        for (let i = 0; i < checkedNodes.length; i++) {
          checkedIds.push(checkedNodes[i].id);
        }

        // 将数组转换为逗号分隔的字符串
        this.rulesIds = checkedIds.join(",");
      } else {
        // 取消所有选中节点
        this.$refs.tree.setCheckedNodes([]);
        this.rulesIds = ""; // 清空data
      }

    },
    handleDelete(row) {
      let api = optimizationAPI();
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delRole(row.id).then(res => {
          if (res.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getList()

          } else {
            processErrors(res);
          }
        })
      }).catch(() => {
      });
    },
    // 展开全部
    unfoldSwitchChange() {
      for (var i in this.$refs.tree.store.nodesMap) {
        this.$refs.tree.store.nodesMap[i].expanded = this.unfoldSwitchValue;
      }
    }
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  margin-left: 10px;
}

.drawer-content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 0;
  background-color: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);
}

.footer-buttons {
  display: flex;
  justify-content: center;
}

.footer-buttons .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

.demo-drawer__content {
  margin-top: 20px;
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}
</style>
